module.exports = __webpack_public_path__ + "img/7200.5dd39228.jpg";